import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import BarLoaderOverlayComponent from 'webapp/components/bar-loader-overlay';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args as TemplatesTransferedNotificationBaseArgs } from 'webapp/components/templates/transfered-notification/base';
import TemplatesTransferedNotificationBaseComponent from 'webapp/components/templates/transfered-notification/base';

export default class TemplatesTransferedNotificationAccountGridItemComponent extends TemplatesTransferedNotificationBaseComponent<TemplatesTransferedNotificationBaseArgs> {
	<template>
		<li class="card card--account-template-notification flex-item {{this.classNames}}">
			<div class="info">
				<div class="anti-stretch">
					<span class="arrow-icon">
						<CommonUiIconComponent @name="ArrowDown" @size="2xl" />
					</span>
					{{#if @model.isTransferedBoardType}}
						<CommonUiIconComponent @name="Databoards" @size="2xl" />
					{{else if @model.isTransferedReportType}}
						<CommonUiIconComponent @name="Reports" @size="2xl" />
					{{/if}}
					<strong>{{@model.title}}</strong>
					<p>{{{@model.shownText}}}</p>
					<div class="bottom">
						<div class="bottom__stretch">
							<a
								role="button"
								class="button"
								{{on "click" (fn this.handleTransferedObject true)}}
							>
								{{@model.acceptText}}
							</a>
							<a
								role="button"
								class="red"
								{{on "click" (fn this.handleTransferedObject false)}}
							>
								<CommonUiIconComponent @name="Trash" @size="sm" />
								Delete
							</a>
						</div>
					</div>
				</div>
			</div>
			<BarLoaderOverlayComponent @isActive={{this.isRequestPending}} />
		</li>
	</template>
}
